import Firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/storage'
// import 'firebase/performance'
import 'firebase/messaging'
import 'firebase/functions'

let config = {
  apiKey: 'AIzaSyAkoSzv4aL9obPV4kIupcxQAcb8j_AnhCQ',
  authDomain: 'b-info.firebaseapp.com',
  databaseURL: 'https://printers-db-b4bde.firebaseio.com',
  projectId: 'b-info',
  storageBucket: 'b-info.appspot.com',
  messagingSenderId: '166512209350'
}

let configListener = {
  apiKey: 'AIzaSyAkoSzv4aL9obPV4kIupcxQAcb8j_AnhCQ',
  authDomain: 'b-info.firebaseapp.com',
  databaseURL: 'https://b-info.firebaseio.com',
  projectId: 'b-info',
  storageBucket: 'b-info.appspot.com',
  messagingSenderId: '166512209350'
}

const firebaseApp = Firebase.initializeApp(config)
// const messaging = Firebase.messaging()
// const fcmIsSupported = messaging.isSupported()
// firebaseApp.firestore.enablePersistence()
const firebaseUsersApp = Firebase.initializeApp(config, 'Secondary')
const firebaseListenerApp = Firebase.initializeApp(configListener, 'Listener')
// const firebaseDBApp = Firebase.initializeApp({ databaseURL: 'https://b-info-a350d.firebaseio.com' }, 'firebaseDBApp')

export const db = firebaseApp.database()
export const dbStore = firebaseApp.firestore()
export const dbListener = firebaseListenerApp.database()

export const dbStoreIncrease = Firebase.firestore.FieldValue.increment(1)
export const dbStoreDecrease = Firebase.firestore.FieldValue.increment(-1)

// export const db = firebaseDBApp.database()
export const storage = firebaseApp.storage()
export const auth = firebaseApp.auth()
export const func = firebaseApp.functions()
// export const perf = firebaseApp.performance()
// export const fcm = firebaseApp.messaging()
// export const fcm = fcmIsSupported ? messaging : null
export const fcm = null
export const timestamp = Firebase.database.ServerValue.TIMESTAMP
export const createAuth = firebaseUsersApp.auth()



// WEBPACK FOOTER //
// ./src/firebase/index.js